angular.module('manufacturing')
    .component('manufacturingOrderStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span ng-if="$ctrl.status != null" class="label label-default manufacturing-order-status {{$ctrl.status}}">{{ 'manufacturing-order.status.'.concat($ctrl.status) | translate }}</span>
        `
    })
